import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, photoUrl } from "../../lib/api";
import { INFO_ICONS, INFO_GRID } from "../../lib/infoBoxes";

const BoxButton = ({ label, link, dark, testid }) => {
  const cls = `mt-4 inline-flex items-center gap-1.5 h-9 px-4 rounded-xl text-sm font-semibold transition-colors ${dark ? "bg-white text-[#12234A] hover:bg-[#FFF4F0]" : "bg-[#F5551E] text-white hover:bg-[#E04812]"}`;
  const inner = <>{label} <ArrowRight size={14} /></>;
  return link.startsWith("/") && !link.startsWith("//")
    ? <Link to={link} className={cls} data-testid={testid}>{inner}</Link>
    : <a href={link} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testid}>{inner}</a>;
};

export const InfoBox = ({ b, lang, testid = `info-box-${b.id}` }) => {
  const fr = lang === "fr";
  const title = (fr && b.title_fr) || b.title_en;
  const body = (fr && b.body_fr) || b.body_en;
  const btn = (fr && b.button_fr) || b.button_en;
  const dark = !!b.bg_image;
  const Icon = (INFO_ICONS[b.icon] || INFO_ICONS.shield).icon;
  return (
    <div data-testid={testid} className={`relative overflow-hidden rounded-2xl border p-7 flex flex-col ${dark ? "border-transparent text-white" : "bg-white border-slate-200/80"}`}>
      {dark && (
        <>
          <img src={photoUrl(b.bg_image)} alt="" className="absolute inset-0 w-full h-full object-cover" data-testid={`${testid}-bg`} />
          <div className="absolute inset-0 bg-gradient-to-t from-[#12234A]/95 via-[#12234A]/70 to-[#12234A]/40" />
        </>
      )}
      <div className="relative flex flex-col flex-1">
        <span className={`h-12 w-12 rounded-xl flex items-center justify-center overflow-hidden ${b.icon_image ? "bg-white/90" : "bg-[#12234A]"} ${dark && !b.icon_image ? "ring-1 ring-white/20" : ""}`}>
          {b.icon_image ? <img src={photoUrl(b.icon_image)} alt="" className="h-9 w-9 object-contain" data-testid={`${testid}-icon-img`} /> : <Icon size={24} className="text-[#F5551E]" />}
        </span>
        {title && <h3 className={`font-display text-lg font-bold mt-4 ${dark ? "text-white" : "text-[#12234A]"}`}>{title}</h3>}
        {body && <p className={`mt-2 text-sm leading-relaxed whitespace-pre-line ${dark ? "text-white/85" : "text-slate-500"}`}>{body}</p>}
        {btn && b.button_link && <div className="mt-auto"><BoxButton label={btn} link={b.button_link} dark={dark} testid={`${testid}-btn`} /></div>}
      </div>
    </div>
  );
};

export const InfoBoxes = ({ lang }) => {
  const [boxes, setBoxes] = useState(null);
  useEffect(() => { api.get("/site/info-boxes").then(({ data }) => setBoxes(data.boxes || [])).catch(() => setBoxes([])); }, []);
  if (!boxes?.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20" data-testid="home-info-boxes">
      <div className={`grid gap-6 ${INFO_GRID[boxes.length] || INFO_GRID[3]} ${boxes.length === 1 ? "mx-auto" : ""}`}>
        {boxes.map((b) => <InfoBox key={b.id} b={b} lang={lang} />)}
      </div>
    </section>
  );
};
